import React, {Component, Children, PropTypes} from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import locale from './locale';
import {alert} from 'util/alert'
import store from 'root/store';

import "./__R.scss";

import 'balloon-css/balloon.css';

/*
 *
 */
export function userCan(can) {
  const schoolId = localStorage.getItem('schoolId');
  const { user } = store.getState();

  if (user && user.rolesPerSchool && schoolId && user.rolesPerSchool[schoolId]) {
    const { permissions, role } = user.rolesPerSchool[schoolId];
    if (role === 'school_owner') {
      return true;
    }

    if (!permissions) {
      return false;
    } else if (permissions && permissions.indexOf(can) > -1) {
      return true;
    } else {
      return false;
    }
  }
}

export function isBasicUser() {
  const { gSubscription } = store.getState();
  const {saas_version} = gSubscription.result;

  return saas_version === 0 || saas_version === 3 || saas_version === 4;
}

export function isValidUser(){
  const { gSubscription } = store.getState();
  const {is_valid, maximum_amount} = gSubscription.result;

  return is_valid && maximum_amount.maximum_school>0;
}

export function isOnlyTeacher(){
  const { user, gSubscription } = store.getState();
  const {is_valid, maximum_amount, saas_version} = gSubscription.result;
  const {teacher_to_be_confirmed, school_amount, school_owned_amount} = user.result;

  return (teacher_to_be_confirmed.length> 0 || (school_amount-school_owned_amount)>0) && saas_version === 0 && !is_valid && maximum_amount.maximum_school === 0;
}
const mapStateToProps = (state) => ({
  user: state.user,
})

class R extends Component{

  static propTypes = {
  }

  constructor(props){
    super(props)
    this.modifyChild = this.modifyChild.bind(this);
  }

  modifyChild(child) {
    const { 
      by, 
      can,
      tooltipPosition = 'down',
      title = __('You do not have permission', locale),
    } = this.props;

    const existingClassName = (child.props || {}).className || '';

    const newClassName = classnames(
      existingClassName,
      {'noPermission--target': by == 'disable'},
    );

    let onClick = {};
    if(by == 'alert'){
      onClick = {
        onClick: (e) => {
          e.stopPropagation()
          e.preventDefault()
          alert.warning(__('You do not have permission', locale))
          .then(() => {})
        }
      }
    }


    return React.cloneElement(child, {
      ...child.props,
      disabled: by == 'disable',
      className: newClassName,
      "data-balloon": title,
      "data-balloon-pos": tooltipPosition,

      ...onClick
      });
  }

  render(){
    const { rolesPerSchool } = this.props.user
    const schoolId = localStorage.getItem('schoolId')

    // if there is no role for the teacher in the school we hide it
    if (!rolesPerSchool || !schoolId || !rolesPerSchool[schoolId]) {
      return <span data-restricted={`hidden by ${can}. User has no role in school.`} />
    }
    
    const { role, permissions, } = rolesPerSchool[schoolId]
    const {
      by = 'hide',
      className,
      can,
    } = this.props;

    if (role === 'school_owner') {
      return <span>{this.props.children}</span>;
    }

    // if undefined, we assume the user is the owner
    if (typeof permissions === 'undefined') {
      return <span>{this.props.children}</span>
    }
    // hiding it by default
    if (by == 'hide' && permissions.indexOf(can) == -1){
      return <span data-restricted={`hidden by ${can}`} />
    }

    if (permissions.indexOf(can) == -1) {
      let newChildren;
      // add disabled class and also disabled attr
      if (Array.isArray(this.props.children)) {
        newChildren = this.props.children.map((child)=>{
          return this.modifyChild(child);
        });
      } else {
        newChildren = this.modifyChild(this.props.children);
      }

      return <span
        dataRestricted={`disabled by ${can}`}
        className={classnames('noPermission', className)}
      >
        {newChildren}
      </span>
    }

    return <span>{this.props.children}</span>;
  }

}


export default connect(mapStateToProps)(R)



// WEBPACK FOOTER //
// ./src/containers/__R/index.js